<template>
  <div id="footer">
    <div class="container">
      <div class="contents">
        <div class="left">
          <div class="txt_contnents">
            <div style="display: flex">
              <p><span>라온메타㈜</span></p>
              <p><span>대표이사</span> 이순형</p>
              <p><span>사업자등록번호</span> 702-86-03034</p>
              <p><span>대표전화</span> 02-761-4540</p>
              <p><span>이메일</span> metademy@raoncorp.com</p>
              <ul>
                <li>
                  <a href="/AgreeTrem" target="_blank">이용약관</a>
                </li>
                <li>|</li>
                <li>
                  <!-- <a
                    class="bold"
                    href="https://privacy.raoncorp.com/raonsecure/ko/web/privacy.html"
                    target="_blank"
                    >개인정보처리방침</a
                  > -->
                  <a class="bold" href="/privacy_policy" target="_blank"
                    >개인정보처리방침</a
                  >
                </li>
              </ul>
            </div>
            <div>
              <p>
                <span>본사</span> 서울특별시 마포구 마포대로 49, 1002호(도화동,
                성우빌딩)
              </p>
              <p>
                (월~금 10:00 ~ 17:00 / 점심시간 12:00~13:00 주말 및 공휴일 휴무)
              </p>
            </div>
            <div>
              <p><span>통신판매업신고</span> 제2024-서울마포-3005호</p>
            </div>
          </div>
          <div class="txt_contnents">
            <p class="copyright">© RaonMeta All rights reserved.</p>
          </div>
        </div>

        <div class="right">
          <div class="more">
            <!-- <select class="niceSelect" @change="familySiteMove">
              <option value="" selected hidden>FAMILY SITE</option>
              <option value="https://www.raoncorp.com">RaonCorporation</option>
              <option value="https://www.raonsecure.com">RaonSecure</option>
              <option value="--">RaonVentures</option>
              <option value="https://www.inbiznetcorp.com">INBIZNET</option>
              <option value="https://www.digitaltrustnetworks.com">
                Digital Trust Networks
              </option>
              <option value="https://www.omnione.net">OmniOne</option>
              <option value="https://www.squp.kr">Security IQ UP</option>
            </select> -->

            <CustomSelect
              :options="familysite"
              default-option="FAMILY SITE"
              @update:selected="handleSelect"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import CustomSelect from './CustomSelectFooter.vue'

export default {
  name: 'AppFooter',
  components: {
    CustomSelect,
  },
  setup() {
    const closingWindow = ref(false)

    const getStayCookie = (name) => {
      const cname = `${name}=`
      const decodedCookie = decodeURIComponent(document.cookie)
      const ca = decodedCookie.split(';')
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) === ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(cname) === 0) {
          return c.substring(cname.length, c.length)
        }
      }
      return ''
    }

    const toDoWhenClosing = () => {
      console.log('Perform action on window closing')
      // 여기에 창 닫힐 때 할 작업을 추가하세요.
    }

    const moveCheck = () => {
      console.log('Checking for inactivity')
      // 여기에 일정 시간 동안 사용자의 활동이 없을 때 수행할 작업을 추가하세요.
    }

    const familySiteMove = (event) => {
      const url = event.target.value
      if (url !== '') {
        if (url !== '--') {
          window.open(url, '_blank')
        } else {
          alert('준비중입니다.')
        }
      }
      // const url = event.target.value;
      // if (url) {
      //   window.location.href = url;
      // }
    }

    onMounted(() => {
      try {
        getStayCookie('staySigned')
        moveCheck()

        window.addEventListener('focus', () => {
          closingWindow.value = false
        })

        window.addEventListener('blur', () => {
          closingWindow.value = true
          if (!document.hidden) {
            closingWindow.value = false
          }

          const resizeHandler = () => {
            closingWindow.value = false
          }

          window.addEventListener('resize', resizeHandler)

          window.removeEventListener('resize', resizeHandler)
        })

        document.documentElement.addEventListener('mouseenter', () => {
          closingWindow.value = false
        })

        document.addEventListener('keydown', (e) => {
          if (e.keyCode === 91 || e.keyCode === 18) {
            closingWindow.value = false
          }
          if (e.keyCode === 116 || (e.ctrlKey && e.keyCode === 82)) {
            closingWindow.value = false
          }
        })

        document.addEventListener('click', (e) => {
          if (
            e.target.tagName === 'A' ||
            e.target.tagName === 'BUTTON' ||
            e.target.tagName === 'FORM'
          ) {
            closingWindow.value = false
          }
        })

        document.documentElement.addEventListener('mouseleave', () => {
          closingWindow.value = true
        })

        window.addEventListener('unload', () => {
          if (closingWindow.value) {
            toDoWhenClosing()
          }
        })
      } catch (err) {
        console.log(err)
      }
    })

    const familysite = [
      'RaonCorporation', // https://www.raoncorp.com
      'RaonSecure', // https://www.raonsecure.com
      'RaonVentures', // none
      'INBIZNET', // https://www.inbiznetcorp.com
      'Digital Trust Networks', // https://www.digitaltrustnetworks.com
      'OmniOne', // https://www.omnione.net
      'Security IQ UP', // https://www.squp.kr
    ]

    const urls = {
      RaonCorporation: 'https://www.raoncorp.com',
      RaonSecure: 'https://www.raonsecure.com',
      RaonVentures: null,
      INBIZNET: 'https://www.inbiznetcorp.com',
      'Digital Trust Networks': 'https://www.digitaltrustnetworks.com',
      OmniOne: 'https://www.omnione.net',
      'Security IQ UP': 'https://www.squp.kr',
    }

    const handleSelect = (selected) => {
      const url = urls[selected]
      if (url) {
        window.open(url, '_blank')
      } else {
        alert(`준비중 입니다.`)
      }
    }

    return {
      familySiteMove,
      familysite,
      handleSelect,
    }
  },
}
</script>
